module.exports = __webpack_public_path__ + "img/brightness.edd91bd2.svg";